import { render, staticRenderFns } from "./ClinicIcon.vue?vue&type=template&id=a49d70c0"
import script from "./ClinicIcon.vue?vue&type=script&lang=js"
export * from "./ClinicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports